module.exports = __webpack_public_path__ + "static/egsepehr-complete-fa878615c753065ce80006e17c6042cd.jpg";